export default "__VITE_ASSET__D6z4JWE2__"